/**
 * Main file used to import all global JavaScript and CSS
 * Non global JavaScript and CSS are added to clientAppEntry.json
 */
import { setup }  from './features/global/index.ts';
import './styles/main.scss';

setup();